module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n\r\n<div class=\"prop-header\"><span class=\"prop-label\">")
    ; __append(escapeFn( parameterTitle ))
    ; __append("</span></div>\r\n\r\n<div class=\"row add_overflow_y\" style=\"margin: 0;\">\r\n    <table id=\"propMainTable\"></table>\r\n</div>\r\n\r\n<div id=\"propMainGridButtons\" style=\"padding-top: 3px; padding-bottom: 5px;\">\r\n    <button type=\"button\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\" style=\"\">\r\n        <i class=\"fa pf-add\" style=\"\"></i>\r\n    </button>\r\n    <button type=\"button\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\" style=\"\">\r\n        <i class=\"fa pf-delete icon-gradient\"></i>\r\n    </button>\r\n</div>")
  }
  return __output;

}